/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mcp_Server_Development_Architect_Detail9Inputs */

const en_svc_mcp_server_development_architect_detail9 = /** @type {(inputs: Svc_Mcp_Server_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tool schemas, auth model and transport design.`)
};

const ar_svc_mcp_server_development_architect_detail9 = /** @type {(inputs: Svc_Mcp_Server_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مخططات الأدوات ونموذج المصادقة وتصميم النقل.`)
};

const bn_svc_mcp_server_development_architect_detail9 = /** @type {(inputs: Svc_Mcp_Server_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`টুল স্কিমা, অথ মডেল আর পরিবহন ডিজাইন।`)
};

const de_svc_mcp_server_development_architect_detail9 = /** @type {(inputs: Svc_Mcp_Server_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tool-Schemas, Auth-Modell und Transport-Design.`)
};

const es_svc_mcp_server_development_architect_detail9 = /** @type {(inputs: Svc_Mcp_Server_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esquemas de herramientas, modelo de autenticación y diseño de transporte.`)
};

const fr_svc_mcp_server_development_architect_detail9 = /** @type {(inputs: Svc_Mcp_Server_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schémas d'outils, modèle d'authentification et conception du transport.`)
};

const pt_svc_mcp_server_development_architect_detail9 = /** @type {(inputs: Svc_Mcp_Server_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esquemas de ferramentas, modelo de autenticação e desenho de transporte.`)
};

const zh_svc_mcp_server_development_architect_detail9 = /** @type {(inputs: Svc_Mcp_Server_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工具结构、认证模型和传输设计。`)
};

const tr_svc_mcp_server_development_architect_detail9 = /** @type {(inputs: Svc_Mcp_Server_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Araç şemaları, kimlik modeli ve taşıma tasarımı.`)
};

const ru_svc_mcp_server_development_architect_detail9 = /** @type {(inputs: Svc_Mcp_Server_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Схемы инструментов, модель авторизации и дизайн транспорта.`)
};

const pl_svc_mcp_server_development_architect_detail9 = /** @type {(inputs: Svc_Mcp_Server_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schematy narzędzi, model uwierzytelniania i projekt transportu.`)
};

/**
* | output |
* | --- |
* | "Tool schemas, auth model and transport design." |
*
* @param {Svc_Mcp_Server_Development_Architect_Detail9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mcp_server_development_architect_detail9 = /** @type {((inputs?: Svc_Mcp_Server_Development_Architect_Detail9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mcp_Server_Development_Architect_Detail9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mcp_server_development_architect_detail9(inputs)
	if (locale === "bn") return bn_svc_mcp_server_development_architect_detail9(inputs)
	if (locale === "de") return de_svc_mcp_server_development_architect_detail9(inputs)
	if (locale === "es") return es_svc_mcp_server_development_architect_detail9(inputs)
	if (locale === "fr") return fr_svc_mcp_server_development_architect_detail9(inputs)
	if (locale === "pt") return pt_svc_mcp_server_development_architect_detail9(inputs)
	if (locale === "zh") return zh_svc_mcp_server_development_architect_detail9(inputs)
	if (locale === "tr") return tr_svc_mcp_server_development_architect_detail9(inputs)
	if (locale === "ru") return ru_svc_mcp_server_development_architect_detail9(inputs)
	if (locale === "pl") return pl_svc_mcp_server_development_architect_detail9(inputs)
	return en_svc_mcp_server_development_architect_detail9(inputs)
});
export { svc_mcp_server_development_architect_detail9 as "svc_mcp-server-development_ARCHITECT_detail" }